import React from 'react'
import List from '../pages/list'

export const PagesOthersList = (props) => <List {...props} filter={{ collection: 'others' }} title="Pages Others" />

export default PagesOthersList
